var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2015 3.04151C15.4418 2.06251 14.3425 1.40408 13.1208 1.1963C11.8992 0.988527 10.644 1.24653 9.60338 1.91932C9.42563 2.03804 9.21667 2.10141 9.00292 2.10141C8.78916 2.10141 8.5802 2.03804 8.40245 1.91932C7.36155 1.2457 6.10577 0.987234 4.88346 1.19503C3.66115 1.40283 2.56132 2.06176 1.80151 3.04151C0.942243 4.16293 0.506362 5.55165 0.570676 6.96295C0.63499 8.37426 1.19537 9.71758 2.15307 10.7562L6.97651 15.9728C7.2323 16.2562 7.5447 16.4827 7.89351 16.6377C8.24233 16.7927 8.61979 16.8728 9.00151 16.8728C9.38322 16.8728 9.76069 16.7927 10.1095 16.6377C10.4583 16.4827 10.7707 16.2562 11.0265 15.9728L15.8488 10.7556C16.8065 9.71719 17.367 8.37405 17.4316 6.96287C17.4961 5.55169 17.0605 4.16301 16.2015 3.04151Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/Favorite.2f6443af.svg";
export { ForwardRef as ReactComponent };